const BarChart = ({ height = '20px', width = '20px', fill = '#2A3135' }) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <g transform="translate(2 1)" fill={fill} fillRule="evenodd">
      <rect y="8.571" width="2.143" height="8.571" rx="1" />
      <rect x="6.429" y="4.286" width="2.143" height="12.857" rx="1" />
      <rect x="12.857" width="2.143" height="17.143" rx="1" />
    </g>
  </svg>
);

export default BarChart;
